import { defineComponent as _defineComponent } from 'vue'
import { useStore, computed, useContext, useRoute } from '@nuxtjs/composition-api';
import { State } from '~/store';
import TLinkButton from '~/components/atoms/t-link-button.vue';

interface Props {
  isFreeResource: boolean | undefined;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ResourcePagePlanCta',
  props: {
    isFreeResource: { type: [Boolean, null] }
  },
  setup(__props: any) {

const { $config, i18n } = useContext();


const store = useStore<State>();
const user = computed(() => store.getters.loggedInUser);
const isFreeUser = computed(() => !user.value || user.value?.subscription?.code === 'free');
const route = useRoute();

return { __sfc: true,$config, i18n, store, user, isFreeUser, route, TLinkButton }
}

})